<template>
  <div>
    <q-toolbar class="column">
      <q-toolbar-title class="text-5 q-mr-auto q-ma-sm">{{ $t('campaigns') }}</q-toolbar-title>
      <q-breadcrumbs class="q-mr-auto q-ma-sm">
        <q-breadcrumbs-el :label="$t('dashboard')" to="/ " />
        <q-breadcrumbs-el :label="$t('campaigns')" exact />
      </q-breadcrumbs>
    </q-toolbar>
    <q-separator spaced />
    <q-toolbar class="q-pr-none q-mb-md">
      <q-space />
      <q-btn
        outline
        icon="mdi-filter-outline"
        color="primary"
        no-caps
        class="q-px-sm q-mx-sm"
        :label="$t('filter')"
        @click="filter = !filter"
      >
        <q-tooltip>{{ $t('filter_campaigns') }}</q-tooltip></q-btn
      >
      <q-btn outline color="primary" icon-right="archive" class="q-mr-sm" no-caps @click="exportCsv" unelevated>
        <q-tooltip>{{ $t('export_csv') }}</q-tooltip>
      </q-btn>
      <q-btn
        unelevated
        color="primary"
        class="q-px-lg"
        icon="mdi-plus"
        :label="$t('add')"
        no-caps
        to="/campaigns/manage"
      />
    </q-toolbar>
    <q-card flat v-if="filter" bordered class="q-mb-sm">
      <q-toolbar>
        <q-btn flat round dense class="q-ml-auto" icon="mdi-close" @click="filter = false" />
      </q-toolbar>
      <q-card-section class="q-pt-none row q-col-gutter-md">
        <div class="col-1">
          <q-input outlined label="ID" :disable="disable_idCampaing" v-model="params.idCampaign" type="text" />
        </div>
        <div class="col-3">
          <select-request
            :v-model="params.campaign"
            :label="$t('campaign')"
            outlined
            endpoint="/redirect?app=ADVERTISER&path=/api/get/campaign/all"
            option-label="name"
            option-value="campaign_id"
            clearable
            @update="updateCampaingSelect"
          />
        </div>
        <div class="col-2">
          <select-request
            :label="$t('manager')"
            :v-model="params.managerId"
            outlined
            endpoint="user/managers-unblocked"
            option-label="name"
            option-value="user_id"
            clearable
            @update="(value) => (params.managerId = value)"
          />
        </div>
        <div class="col-3">
          <select-request
            :v-model="params.advertiserId"
            :label="$t('advertiser')"
            outlined
            endpoint="redirect?app=ADVERTISER&path=/api/get/advertiser/bytype/anunciante"
            option-label="trademark"
            option-value="id"
            clearable
            @update="(value) => (params.advertiserId = value)"
          />
        </div>
        <div class="col-3">
          <select-request
            :v-model="params.agencyId"
            :label="$t('agency')"
            outlined
            endpoint="redirect?app=ADVERTISER&path=/api/get/advertiser/bytype/agencia"
            option-label="trademark"
            option-value="id"
            clearable
            @update="(value) => (params.agencyId = value)"
          />
        </div>
        <div class="col-4">
          <select-request
            :label="$t('category')"
            :v-model="params.categoryId"
            outlined
            endpoint="redirect?app=ADVERTISER&path=/api/get/campaign/category/filter"
            option-label="name"
            option-value="id"
            clearable
            @update="(value) => (params.categoryId = value)"
          />
        </div>
        <div class="col-4">
          <select-request
            :label="$t('segmentation')"
            :v-model="params.segmentation"
            outlined
            endpoint="redirect?app=ADVERTISER&path=/api/get/campaign/segmentation"
            option-label="description"
            option-value="id"
            clearable
            @update="(value) => (params.segmentation = value === null ? null : value.id)"
          />
        </div>
        <div class="col-4">
          <q-input outlined label="Action ID" v-model="params.actionId" type="text" />
        </div>
        <div class="col-8">
          <q-card flat>
            <q-card-section class="q-pa-none">
              <span class="text-weight-medium">{{ $t('status') }}</span>
              <div class="q-gutter-sm">
                <q-checkbox v-model="params.status" val="1" :label="$t('activated')" color="primary" />
                <q-checkbox v-model="params.status" val="2" :label="$t('paused')" color="accent" />
                <q-checkbox v-model="params.status" val="3" :label="$t('disabled')" color="negative" />
                <q-checkbox v-model="params.status" val="0" :label="$t('pending')" color="warning" />
                <q-checkbox v-model="params.status" val="4" :label="$t('in_implementation')" color="purple" />
              </div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-4">
          <q-card flat>
            <span class="text-weight-medium">{{ $t('type') }}</span>
            <div class="q-gutter-sm">
              <q-checkbox v-model="params.type" val="CPL" label="CPL" color="orange" />
              <q-checkbox v-model="params.type" val="CPA" label="CPA" color="teal" />
              <q-checkbox v-model="params.type" val="CPC" label="CPC" color="cyan" />
            </div>
          </q-card>
        </div>
        <div class="col-12 row flex justify-between">
          <div class="q-gutter-sm row">
            <q-card flat>
              <q-checkbox
                v-model="params.is_test"
                :false-value="true"
                :true-value="false"
                :label="$t('dont_show_test_campaign')"
              />
            </q-card>

            <q-card flat>
              <q-checkbox v-model="params.is_exclusive" :label="$t('exclusive_campaigns')" />
            </q-card>
          </div>
          <q-btn color="positive" :label="$t('search')" no-caps unelevated class="q-px-md" @click="onFilterCampaigns" />
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import CampaignMixin from '../../mixins/CampaignMixin';
import AdvertiserMixin from '@/mixins/AdvertiserMixin.js';
import SelectRequest from '@/widgets/inputsGlobal/SelectRequest.vue';

export default {
  name: 'HeaderCampaign',
  mixins: [CampaignMixin, AdvertiserMixin],
  components: { SelectRequest },
  data() {
    return {
      filter: true,
      params: {
        idCampaign: null,
        campaign: null,
        managerId: null,
        advertiserId: null,
        agencyId: null,
        categoryId: null,
        actionId: null,
        status: [],
        type: [],
        is_test: false,
        is_exclusive: false
      },
      disable_idCampaing: false
    };
  },
  methods: {
    updateCampaingSelect(value) {
      if (value) {
        this.disable_idCampaing = true;
        this.params.idCampaign = value.id;
        this.params.campaign = value;
      } else {
        this.params.idCampaign = null;
        this.disable_idCampaing = false;
        this.params.campaign = null;
      }
    },

    clearFilter() {
      this.params = {
        idCampaign: null,
        campaign: null,
        managerId: null,
        advertiserId: null,
        agencyId: null,
        categoryId: null,
        status: [],
        type: []
      };
      this.ActionSetFilterCampaign();
      this.getCampaigns();
    },
    onFilterCampaigns() {
      let filterSelect = [];

      if (this.params.campaign) filterSelect.push(`id=${this.params.campaign.id}`);
      else if (this.params.idCampaign) filterSelect.push(`id=${this.params.idCampaign}`);
      if (this.params.managerId) filterSelect.push(`managerId=${this.params.managerId.user_id}`);
      if (this.params.segmentation) filterSelect.push(`segmentation=${this.params.segmentation}`);
      if (this.params.advertiserId) filterSelect.push(`advertiserId=${this.params.advertiserId.id}`);
      if (this.params.agencyId) filterSelect.push(`agencyId=${this.params.agencyId.id}`);
      if (this.params.categoryId) filterSelect.push(`categoryId=${this.params.categoryId.id}`);
      if (this.params.actionId) filterSelect.push(`action_id=${this.params.actionId}`);
      if (this.params.type.length)
        filterSelect.push(`comissionType=[${this.params.type.map((item) => (item = `"${item}"`))}]`);
      if (this.params.status.length)
        filterSelect.push(`status=[${this.params.status.map((item) => (item = `"${item}"`))}]`);
      if (this.params.is_test === false) filterSelect.push(`is_test=0`);
      if (this.params.is_exclusive) filterSelect.push(`is_exclusive=1`);

      const page = localStorage.getItem('currentPage') || 1;
      const perPage = localStorage.getItem('rowsPerPage') || 10;

      this.ActionSetFilterCampaign(filterSelect.join('%26'));
      this.getCampaigns('page=' + page, 'perPage=' + perPage);
    },

    async exportCsv() {
      try {
        this.onLoading(true);

        const { data } = await this.searchCampaign(1, 1, this.filterCampaign + '%26showAll%3Dtrue');

        this.exportTableCsv(this.prepareItemCSV(data), this.manageCampaignsVisibleColumns);
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  }
};
</script>

<style></style>
